function isNewCar() {
  return (
    typeof window !== "undefined" &&
    window?.location?.href?.includes("/new-car/")
  );
}

export default isNewCar;
